(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/create-game/assets/javascripts/helpers/get-product-items.js') >= 0) return;  svs.modules.push('/components/marketplace-data/create-game/assets/javascripts/helpers/get-product-items.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _svs$components$marke = svs.components.marketplaceData.createGame.constants,
  BUY_STOP_DIFF = _svs$components$marke.BUY_STOP_DIFF,
  DISABLED_REASONS = _svs$components$marke.DISABLED_REASONS;
const NO_DRAW = DISABLED_REASONS.NO_DRAW,
  MINIMUM_DIFF_TO_DRAW_PASSED = DISABLED_REASONS.MINIMUM_DIFF_TO_DRAW_PASSED;
const getJackpots = svs.content.shared.getJackpots;
const getFunds = svs.components.lbUtils.funds.getFunds;
const TTLCacheAsync = svs.components.lbUtils.ttlCache.TTLCacheAsync;
const CACHE_ID = 'fundsAndJackpotsCache';
const CACHE_TIME = 120000000; 
const CACHE_TIMEOUT = 3000; 

const _queryJackpotAndFunds = async _ref => {
  let payload = _ref.payload;
  const allProductNames = payload.allProductNames;
  const _await$Promise$all = await Promise.all([getJackpots(allProductNames), getFunds({
      products: allProductNames
    })]),
    _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
    jackpots = _await$Promise$all2[0],
    funds = _await$Promise$all2[1];
  return {
    jackpots,
    funds
  };
};
const Global = Object.seal({
  jackpotAndFundsCache: new TTLCacheAsync({
    onRefreshAsync: _queryJackpotAndFunds,
    ttl: CACHE_TIME,
    timeoutMS: CACHE_TIMEOUT
  })
});
const getProductItems = async _ref2 => {
  let _ref2$allProductNames = _ref2.allProductNames,
    allProductNames = _ref2$allProductNames === void 0 ? [] : _ref2$allProductNames,
    _ref2$drawsByProduct = _ref2.drawsByProduct,
    drawsByProduct = _ref2$drawsByProduct === void 0 ? [] : _ref2$drawsByProduct,
    _ref2$buyStop = _ref2.buyStop,
    buyStop = _ref2$buyStop === void 0 ? BUY_STOP_DIFF : _ref2$buyStop;
  const minimumBufferInMs = buyStop * 60 * 1000;
  const now = Date.now();
  const latestClosingTime = new Date(now + minimumBufferInMs);
  const cachedData = (await Global.jackpotAndFundsCache.readAsync({
    key: CACHE_ID,
    payload: {
      allProductNames
    }
  })) || {};
  const jackpots = (cachedData === null || cachedData === void 0 ? void 0 : cachedData.jackpots) || [];
  const funds = (cachedData === null || cachedData === void 0 ? void 0 : cachedData.funds) || [];
  const getJackpotsByProductName = productName => jackpots.filter(jackpot => jackpot.productName.toLowerCase() === productName.toLowerCase());
  const getFundsByProductName = productName => funds.filter(fund => fund.productName.toLowerCase() === productName.toLowerCase());
  const productItems = await Promise.all(allProductNames.map(async item => {
    const drawsForProduct = drawsByProduct[item];
    if ((drawsForProduct || []).length === 0) {
      return {
        item,
        disabledReason: NO_DRAW,
        isDisabled: true
      };
    }
    const disabledReason = drawsForProduct.some(draw => new Date(draw.regCloseTime) > latestClosingTime) ? undefined : MINIMUM_DIFF_TO_DRAW_PASSED;
    return {
      item,
      disabledReason,
      isDisabled: Boolean(disabledReason),
      jackpots: getJackpotsByProductName(item),
      funds: getFundsByProductName(item)
    };
  }));
  return productItems;
};
setGlobal('svs.components.marketplaceData.createGame.helpers.getProductItems', getProductItems);

 })(window);